export const state = {
  credentials: {
    username: undefined,
    password: undefined,
    authCode: undefined
  }
}

export default state



// WEBPACK FOOTER //
// ./src/store/module/signIn/state.js